import { IEmploymentProps } from '@my-pages/features/employment/types';
import { formatDate } from '@shared/utils/dateUtils.ts';

const Employment = ({ employment }: IEmploymentProps) => {
    return (
        <>
            <h4 className='highlight-mask'>{employment.employmentName}</h4>
            {!(employment.visitAdress && employment.visitZip) && (
                <p>
                    Adressuppgifter saknas
                    <br />
                </p>
            )}
            {(employment.visitAdress || employment.visitZip) && (
                <p className='highlight-mask'>
                    {employment.visitAdress}
                    <br />
                    {employment.visitZip} {employment.visitCity}
                </p>
            )}
            <div className='ft-table ft-flush table-mark-empty mb-0 font-size-sm'>
                {employment.employmentStartDate && (
                    <div className='ft-tr'>
                        <div className='ft-th'>Start</div>
                        <div className='ft-td'>{formatDate(employment.employmentStartDate)}</div>
                    </div>
                )}
                {employment.employmentEndDate && (
                    <div className='ft-tr'>
                        <div className='ft-th'>Slut</div>
                        <div className='ft-td'>{formatDate(employment.employmentEndDate)}</div>
                    </div>
                )}
            </div>
        </>
    );
};
export default Employment;
